<template>
  <div>菜单权限</div>
</template>

<script setup>

</script>

<style scoped>

</style>
